import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { CareElementOperatorType } from "../CareElementOperatorType";
import { BaseCareElement } from "./BaseCareElement";
import { CareElementType } from "./CareElementType";

/**
 * Care element that captures an Agent and a Dose with a reviewed date, similar to other reviewed elements.
 */
export class AgentDoseReviewedCareElement extends BaseCareElement {
    public Name: string;
    public CareElementType: CareElementType.AgentDoseReviewed;
    public Agent?: string | null;
    public Dose?: string | null;
    public Target?: string | null;
    public SubSectionName: string;
    public DateReviewed?: Date | null;
    public LastReviewedDate?: Date | null;
    public Frequency?: CareElementFrequencyType | null;
    public Operator?: CareElementOperatorType | null;
    public DateReviewedWithPrecision?: DateTimeWithPrecision | null;

    public constructor(init?: NonFunctionProperties<AgentDoseReviewedCareElement>) {
        super();
        this.CareElementType = CareElementType.AgentDoseReviewed;
        this.Name = init?.Name ?? "";
        this.Agent = init?.Agent ?? null;
        this.Dose = init?.Dose ?? null;
        this.Target = init?.Target ?? null;
        this.SubSectionName = init?.SubSectionName ?? "";
        this.DateReviewed = init?.DateReviewed ?? null;
        this.LastReviewedDate = init?.LastReviewedDate ?? null;
        this.Frequency = init?.Frequency ?? null;
        this.Operator = init?.Operator ?? null;
        this.DateReviewedWithPrecision = init.DateReviewedWithPrecision ?? DateTimeWithPrecision.getDate(init?.DateReviewed);
    }
}
